// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"40":"75e72e25","808":"caaa5758"}[chunkId] + ".chunk.css";
};